import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {ChooseCardComponent} from "./components/ChooseCardComponent";
import {PayWithAddedCardComponent} from "./components/PayWithAddedCardComponent";
import {UsingCardComponent} from "./components/UsingCardComponent";

import {BasePanelPage} from "../BasePanelPage";
import {Messages} from "../../../../Messages";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {PaywallToast} from "../../../PaywallToast";
import {Device} from "../../../../../stem-core/src/base/Device";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {CARD_SECTION_STATE, paymentMethodController} from "../../../inline-donation/PaymentMethodController";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Router} from "../../../../../stem-core/src/ui/Router";


const CARD_SECTION_MAP = {
    [CARD_SECTION_STATE.chooseCard]: ChooseCardComponent,
    [CARD_SECTION_STATE.payWithAddedCard]: PayWithAddedCardComponent,
    [CARD_SECTION_STATE.usingCard]: UsingCardComponent,
    [CARD_SECTION_STATE.addCard]: PayWithAddedCardComponent,
};

export class PaymentMethodPanel extends BasePanelPage {
    getCardSectionState() {
        if ((!paymentMethodController.initialPaymentMethod && !iFrameUserDataService.getExtraPaymentMethodCount())
            || iFrameMerchantService.isCDSPaymentMethod()) {
            paymentMethodController.cardSectionState = CARD_SECTION_STATE.payWithAddedCard;
        }
        return paymentMethodController.cardSectionState;
    }

    render() {
        if (!paymentMethodController.selectedPaymentMethod) {
            paymentMethodController.selectedPaymentMethod = paymentMethodController.getInitialPaymentMethod();
            paymentMethodController.initialPaymentMethod = paymentMethodController.getInitialPaymentMethod();
        }

        const CardSectionClass = CARD_SECTION_MAP[this.getCardSectionState()];
        const onAddCard = () => {
            paymentMethodController.cardSectionState = CARD_SECTION_STATE.addCard;
            Router.updateURL();
        };

        return [
            <CardSectionClass card={paymentMethodController.selectedPaymentMethod} className={this.styleSheet.cardComponent}
                              hideActiveCard={true} onChange={() => this.redraw()} onAddCard={onAddCard}
                              entry={paymentMethodController.entry}
                              ref="cardComponent"/>,
            this.renderButtonSection(),
        ];
    }

    isButtonDisabled() {
        return !(this.cardComponent && this.cardComponent.isValid());
    }

    renderButtonSection() {
        const {styleSheet} = this;
        const cancelAddCard = () => {
            paymentMethodController.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
        };

        if (this.getCardSectionState() === CARD_SECTION_STATE.chooseCard ||
            this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard) {
            return [
                <MerchantButton ref="button" className={styleSheet.button} disabled={this.isButtonDisabled()}
                                label={this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard ?
                                    paymentMethodController.getPayWithAddedCardButtonLabel() :
                                    paymentMethodController.getChooseCardButtonLabel()}
                                onClick={() => this.continueWithChosenCard()} />,
                Device.isMobileDevice() ? null :
                <div className={styleSheet.center}>
                    <div className={styleSheet.secondaryButton} onClick={() => {
                            paymentMethodController.onSelectCancel();
                        }}>
                        {Messages.back}
                    </div>
                </div>
            ];
        }
        return [
            <MerchantButton className={styleSheet.button} ref="button" label={Messages.continue}
                            onClick={() => this.addCard()} disabled={this.isButtonDisabled()}/>,
            <div className={styleSheet.center}>
                <div onClick={cancelAddCard} className={styleSheet.secondaryButton}>
                    {Messages.cancel}
                </div>
            </div>
        ];
    }

    continueWithChosenCard() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(paymentMethodController.getScope(), preferredPaymentMethodId => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                paymentMethodController.selectedPaymentMethod = preferredPaymentMethodId;
            } else {
                paymentMethodController.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            }

            paymentMethodController.onSelectSuccess();
        }, error => {
            if (paymentMethodController.cardSectionState === CARD_SECTION_STATE.chooseCard) {
                PaywallToast.showError(error.message);
            }
            LoadingSpinner.hide();
        });
    }

    addCard() {
        LoadingSpinner.show();
        this.cardComponent.getPaymentMethodId(paymentMethodController.getScope(), preferredPaymentMethodId => {
            paymentMethodController.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            paymentMethodController.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
            LoadingSpinner.hide();
        }, () => LoadingSpinner.hide());
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
